import React, { useState } from "react";
import PropTypes from "prop-types";

import DetectDeviceResize from "shared-anpost-components/hooks/detectDeviceResizeHook";

import { PhoneBannerStyled } from "./PhoneBannerStyled";
import phoneNotification from "../../../images/phoneNotification.png";
import VerifyPhoneNumberWrapper from "../../_core/sidePanelForms/verifyPhoneNumber";

/**
 * PhoneBanner component
 * @param {{
 *  heading: string,
 *  singleItem: boolean,
 *  onVerified: () => void
 * }} props
 */

const PhoneBanner = ({ heading, singleItem, onVerified }) => {
    const { isMobile } = DetectDeviceResize();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const clickHandler = () => {
        setIsModalOpen(true);
    };

    return (
        <>
            <PhoneBannerStyled>
                <div className="titleContent">{heading || "Not seeing all your deliveries?"}</div>
                <div className="imgWrapper">
                    <img src={phoneNotification} alt="phone" />
                </div>
                <div className="infoContent">
                    We use your mobile number to identify your parcels so we can include them in your deliveries. {!isMobile && <br />}
                    <button type="button" onClick={clickHandler} className="linkWrapper gtm-banner">
                        Verify mobile number
                    </button>
                </div>
            </PhoneBannerStyled>
            <VerifyPhoneNumberWrapper isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} singleItem={singleItem} onVerified={onVerified} />
        </>
    );
};

export default PhoneBanner;

PhoneBanner.propTypes = {
    heading: PropTypes.string,
    singleItem: PropTypes.bool,
    onVerified: PropTypes.func
};
